<div class="row">
  <div class="no-print">
    <!-- -->
    <app-section-banner [section]="'orders'" [title]="'4DML Ordering'" [subtitle]="subtitle" [detail]="detail"> </app-section-banner>

    <!-- SELECT SITE -->
    <div class="col-xs-12 delivery-site">
      @if (!site) {
        <h3>Delivery site</h3>
      }
    </div>
    @if (!site && !creatingSite) {
      <div class="col-xs-12">
        <div class="panel panel-default site-choice" (click)="creatingSite = true">
          <div class="panel-body"><i class="fa fa-plus"></i>&nbsp; Create a new site</div>
        </div>
      </div>
    }

    @if (!site && creatingSite) {
      <div class="col-xs-12">
        <app-address-entry [titleLabel]="'Site Name'" (submit)="newSiteSubmit($event)" (cancel)="creatingSite = false"> </app-address-entry>
      </div>
    }

    @if (!site && !creatingSite) {
      <div class="col-xs-12">
        <div class="component-list">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Site</th>
                <th class="hidden-xs">Address</th>
                <th>PostCode</th>
                <th>Org</th>
              </tr>
            </thead>
            <tbody>
              @for (site of sites; track site; let i = $index) {
                <tr (click)="selectSite(site)">
                  <td>{{ site.title }}</td>
                  <td class="hidden-xs">{{ site.address.address1 }}</td>
                  <td>{{ site.address.addressPostcode }}</td>
                  <td>{{ site.org.shortTitle }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    <!-- /SITE SELECTED -->

    <!-- SURVEY COMPLETED / SKIPPED -->
  </div>
  @if (site) {
    <div class="col-xs-12">
      <div class="row site-header">
        <div class="col-xs-8 address">
          <blockquote>
            @if (site.title) {
              <p class="">{{ site.title }}</p>
            }
            <p class="">{{ site.address.address1 }}</p>
            @if (site.address.address2) {
              <p class="">{{ site.address.address2 }}</p>
            }
            @if (site.address.address3) {
              <p class="">{{ site.address.address3 }}</p>
            }
            <p class="">{{ site.address.addressTown }}</p>
            <p class="">{{ site.address.addressCounty }}</p>
            <p class="">{{ site.address.addressPostcode }}</p>
          </blockquote>
        </div>
        <div class="col-xs-4">
          <button class="btn btn-sm btn-default pull-right no-print" (click)="selectSite()">Choose another site.</button>
        </div>
      </div>
      <!-- SELECT DATE -->
      @if (site) {
        <div class="no-print text-center col-sm-6 date-entry">
          <h4><i class="fa fa-fw fa-truck"></i> Delivery Date</h4>
          <!-- <p-calendar [(ngModel)]="deliverAt" [dateFormat]="getDateFormat().toLowerCase()" [locale]="en" [showIcon]="true" [minDate]="minDeliveryDate" [defaultDate]="minDeliveryDate" (onBlur)="dateBlur()" (onSelect)="dateBlur()" [inline]="true"></p-calendar>-->
        </div>
      }
      @if (site) {
        <div class="text-center col-sm-6 date-entry">
          <h4><i class="fa fa-fw fa-plug"></i> Install Date</h4>
          <!-- <p-calendar [(ngModel)]="installAt" [dateFormat]="getDateFormat().toLowerCase()" [locale]="en" [showIcon]="true" [minDate]="minInstallDate" [defaultDate]="minInstallDate" (onBlur)="dateBlur()" (onSelect)="dateBlur()" [inline]="true"></p-calendar>    -->
        </div>
      }
      @if (!surveyCompleted) {
        <div class="row collections no-print">
          <div class="col-xs-12">
            <h3>Site Survey</h3>
          </div>
          @for (item of collections; track item) {
            <div class="col-xs-12 col-md-6">
              <app-order-collection-item [item]="item"></app-order-collection-item>
            </div>
          }
        </div>
      }
      <div class="row">
        <div class="col-xs-12 no-print">
          <h3>Parts Confirmation</h3>
        </div>
        <div class="col-xs-12 receipt-col">
          <div class="row receipt banner">
            <div class="">
              <p>
                Deliver to {{ site.address1 }} @if (deliverAt) {
                <span> by {{ deliverAt.toLocaleDateString() }}</span>
                } @if (installAt) {
                <span>for installation on {{ installAt.toLocaleDateString() }}</span>
              }
            </p>
            @for (item of collections; track item) {
              <div class="col-xs-12 col-md-12">
                @if (item.qty) {
                  <div class="collection-item">{{ item.title }}</div>
                }
              </div>
              @for (inventory of item.inventorys; track inventory) {
                <div class="col-xs-12 col-md-12">
                  @if (item.qty) {
                    <div class="collection-part">
                      {{ inventory.title }} <span class="pull-right">{{ inventory.qty * item.qty }}</span>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      </div>
      <div class="col-xs-12 text-center no-print order-actions">
        <button class="btn btn-secondary" (click)="save('editing')">Save order, don't submit yet</button>
        <button class="btn btn-success" (click)="save('submit')">Order ready, submit for authorisation</button>
        @if (orderId) {
          <button class="btn btn-danger" (click)="orderCancel('')">Cancel this order</button>
        }
        <br />
      </div>
    </div>
    <!-- ORDER PICKER - DEPRECTAED BY SURVEY -->
    @if (false) {
      <div class="row inventory no-print">
        @for (item of inventorys; track item) {
          <div class="col-xs-12 col-sm-6">
            <div class="panel panel-default panel-fourd inventory-item">
              <div class="panel-heading">
                <h3 class="panel-title">{{ item.title }}</h3>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 image">
                    <img class="img-responsive" src="https://s3.eu-west-2.amazonaws.com/4d-inventory/{{ item.shortTitle }}-1-160.jpg" />
                    {{ item.description }}
                  </div>
                  <div class="col-xs-12">
                    <form class="form-inline pull-right">
                      <div class="form-group quantity">
                        <label for="orderquantity">Quantity: </label>
                        <div class="input-group">
                          <input name="qty" class="form-control" aria-label="Order Quantity" [(ngModel)]="item.order.qty" />
                          <div class="input-group-btn">
                            <button type="button" class="btn btn-default" aria-label="Help" (click)="incdec(1, item)">
                              <i class="fa fa-plus-circle"></i>
                            </button>
                            <button type="button" class="btn btn-default" aria-label="Help" (click)="incdec(-1, item)">
                              <i class="fa fa-minus-circle"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
</div>
<!-- @TODO
<p-confirmDialog [icon]="dialogIcon" header="Confirmation">
  {{dialogText}}
</p-confirmDialog>
-->
